import { createSlice } from '@reduxjs/toolkit';
import { sessionApi } from '../services/sessionApi';

const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    session: null,
    qrCode: {
      uid: null,
      timeStamp: null
    },
    confirmedSession: null,
    componentsModRes: null,
    sessionSendCompleted: null 
  },
  reducers: {
    clearSession: (state) => {
      state.session = null;
      state.confirmedSession = null;
      state.componentsModRes = null;
      state.sessionSendCompleted = null;
    },
    clearModRes: (state) => {
      state.componentsModRes = null;
    },
    setQrCode: (state, action) => {
      state.qrCode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(sessionApi.endpoints.newSession.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.session = payload?.payload
      })
      .addMatcher(sessionApi.endpoints.newSession.matchRejected, (state, { error }) => {
        console.log(error.message);
      })
      .addMatcher(sessionApi.endpoints.cancelSession.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.session = null
      })
      .addMatcher(sessionApi.endpoints.cancelSession.matchRejected, (state, { error }) => {
        console.log(error);
        state.session = null
      })
      .addMatcher(sessionApi.endpoints.setSession.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.confirmedSession = payload?.payload
      })
      .addMatcher(sessionApi.endpoints.setSession.matchRejected, (state, { error }) => {
        console.log(error);
        // state.confirmedSession = null
      })
      .addMatcher(sessionApi.endpoints.modifyComponents.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.componentsModRes = payload?.payload
        // state.confirmedSession = payload?.payload
      })
      .addMatcher(sessionApi.endpoints.modifyComponents.matchRejected, (state, { error }) => {
        console.log(error);
        // state.confirmedSession = null
      })
      .addMatcher(sessionApi.endpoints.activateSession.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.sessionSendCompleted = payload?.payload
        // state.confirmedSession = payload?.payload
      })
      .addMatcher(sessionApi.endpoints.activateSession.matchRejected, (state, { error }) => {
        console.log(error);
        // state.confirmedSession = null
      })
  },
});

export const { clearSession, setQrCode, clearModRes } = sessionSlice.actions;
export default sessionSlice.reducer;
